import { __assign } from "tslib";
import { connect } from 'react-redux';
import { getThreadState } from '../../selectors';
import { getCurrentAdSafety } from '../../../Ads/redux/selectors';
var mapStateToProps = function (state, _a) {
    var commentableTypeId = _a.commentableTypeId, commentableItemId = _a.commentableItemId, parentId = _a.parentId;
    var threadState = getThreadState(state, commentableTypeId, commentableItemId, parentId);
    return __assign(__assign({}, threadState), { itemCount: threadState.items.length, adSafety: getCurrentAdSafety(state) || '' });
};
export default connect(mapStateToProps);
//# sourceMappingURL=SimpleThread.container.js.map